import React, { useEffect, useState } from 'react';
import { getNextPuzzleTime } from '../../utils/puzzleId';

const pad = (n) => String(n).padStart(2, '0');

/**
 * Time until the next puzzle unlocks.
 *
 * The target instant is computed once, not per tick: finding it is a binary
 * search over Eastern-time formatting (Eastern days are 23 or 25 hours long
 * twice a year, so it cannot be plain offset arithmetic), and doing that every
 * second would be wasteful.
 */
const NextPuzzleCountdown = () => {
  const [target] = useState(() => getNextPuzzleTime());
  const [remaining, setRemaining] = useState(() => target - Date.now());

  useEffect(() => {
    const id = setInterval(() => setRemaining(target - Date.now()), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (remaining <= 0) {
    return (
      <button
        type="button"
        className="summary-next-ready"
        onClick={() => window.location.assign('/')}
      >
        New puzzle ready — play →
      </button>
    );
  }

  const secs = Math.floor(remaining / 1000);
  return (
    <p className="summary-countdown">
      Next puzzle in{' '}
      <strong>
        {pad(Math.floor(secs / 3600))}:{pad(Math.floor((secs % 3600) / 60))}:{pad(secs % 60)}
      </strong>
    </p>
  );
};

export default NextPuzzleCountdown;
